import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'

import { ErrorState } from '@/components/feedback/ErrorState'

/** `errorElement` for the router: renders 404s and unexpected route crashes. */
export function RouteError() {
  const error = useRouteError()
  const navigate = useNavigate()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <ErrorState
        title="Seite nicht gefunden"
        error={new Error('Diese Seite gibt es nicht oder sie wurde verschoben.')}
        onRetry={() => navigate('/')}
      />
    )
  }

  return <ErrorState error={error} onRetry={() => navigate(0)} />
}
